import fetch from '../../../../utils/fetch'
import {FILE_ACTION_TYPES} from '../../../constants/actionTypes'

const getInitialState = () => {
  return {
    isLoading: false,
    project: null,
    error: null,

    isLoadingBanner: false,
    banner: null,
    errorBanner: null,

    isLoadingLogo: false,
    logo: null,
    errorLogo: null,
  };
};
const state = getInitialState();

const getters = {
  isLoading(state) {
    return state.isLoading
  },
  project(state) {
    return state.project
  },
  error(state) {
    return state.error
  },
  isLoadingBanner(state) {
    return state.isLoadingBanner
  },
  banner(state) {
    return state.banner
  },
  errorBanner(state) {
    return state.errorBanner
  },
  isLoadingLogo(state) {
    return state.isLoadingLogo
  },
  logo(state) {
    return state.logo
  },
  errorLogo(state) {
    return state.errorLogo
  },
}

const actions = {

  // Create new project
  create({commit, dispatch}, data) {
    commit(types.SET_NEW_PROJECT_LOADING);
    return fetch('/projects', {method: 'POST', body: JSON.stringify(data)})
      .then(response => response.json())
      .then((data) => {
        commit(types.SET_NEW_PROJECT, data)
        // Fetch project memberships
        dispatch('user/profile/fetchSession', null, {root: true})
        return data
      })
      .catch((error) => {
        commit(types.SET_NEW_PROJECT_ERROR, error)
      })
  },

  reset({commit}) {
    commit(types.RESET)
  },

  // Upload project banner
  async uploadBanner({commit, state, dispatch}, bannerPayload) {
    if (bannerPayload.type !== FILE_ACTION_TYPES.project_banner.name) {
      console.log('Project banner actionType not set or incorrect.', bannerPayload)
      return
    }
    commit(types.SET_BANNER_LOADING)

    // build form data
    const fileObject = {
      blob: bannerPayload.blob,
      name: bannerPayload.name,
      type: bannerPayload.type,
    }
    const formData = new FormData()
    formData.append('file', fileObject.blob, fileObject.name)
    formData.append('actionType', fileObject.type)

    // If a banner exists, replace instead of a new upload
    let url = '/file_objects'
    // If a file exists, replace it instead of creating a new one
    if (state.banner) {
      url = state.banner.response['@id']
    }

    return fetch(url, {
      method: 'POST', body: formData
    }).then((response) => {
      return response.json()
    }).then((data) => {
      commit(types.SET_BANNER, {response: data, name: fileObject.name, type: fileObject.type})
    }).catch((error) => {
      commit(types.SET_BANNER_ERROR, {error, name: fileObject.name, type: fileObject.type})
    })
  },

  deleteBanner({commit, state}) {
    if (!state.banner) {
      console.log('No project banner uploaded')
      return
    }
    commit(types.SET_BANNER_LOADING)
    return fetch(state.banner.response['@id'], {method: 'DELETE'})
      .then((response) => {
        return response.status === 204
      })
      .then((isDeleted) => {
        if (isDeleted) {
          commit(types.SET_BANNER, null)
        } else {
          commit(types.SET_BANNER_ERROR, 'Error removing project banner')
        }
      })
      .catch((e) => {
        commit(types.SET_BANNER_ERROR, e.message)
      })
  },

  // Upload project logo
  async uploadLogo({commit, state}, logoPayload) {
    if (logoPayload.type !== FILE_ACTION_TYPES.project_image.name) {
      console.log('Project logo actionType not set or incorrect.', logoPayload)
      return
    }
    commit(types.SET_LOGO_LOADING)

    // build form data
    const fileObject = {
      blob: logoPayload.blob,
      name: logoPayload.name,
      type: logoPayload.type,
    }
    const formData = new FormData()
    formData.append('file', fileObject.blob, fileObject.name)
    formData.append('actionType', fileObject.type)

    // If a logo exists, replace instead of a new upload
    let url = '/file_objects'
    // If a file exists, replace it instead of creating a new one
    if (state.logo) {
      url = state.logo.response['@id']
    }

    return fetch(url, {
      method: 'POST', body: formData
    }).then((response) => {
      return response.json()
    }).then((data) => {
      commit(types.SET_LOGO, {response: data, name: fileObject.name, type: fileObject.type})
    }).catch((error) => {
      commit(types.SET_LOGO_ERROR, {error, name: fileObject.name, type: fileObject.type})
    })
  },

  deleteLogo({commit, state}) {
    if (!state.logo) {
      console.log('No project logo uploaded')
      return
    }
    commit(types.SET_LOGO_LOADING)
    return fetch(state.logo.response['@id'], {method: 'DELETE'})
      .then((response) => {
        return response.status === 204
      })
      .then((isDeleted) => {
        if (isDeleted) {
          commit(types.SET_LOGO, null)
        } else {
          commit(types.SET_LOGO_ERROR, 'Error removing project logo')
        }
      })
      .catch((e) => {
        commit(types.SET_LOGO_ERROR, e.message)
      })
  },
}

const types = {
  SET_NEW_PROJECT_LOADING: 'SET_NEW_PROJECT_LOADING',
  SET_NEW_PROJECT: 'SET_NEW_PROJECT',
  SET_NEW_PROJECT_ERROR: 'SET_NEW_PROJECT_ERROR',
  SET_BANNER_LOADING: 'SET_BANNER_LOADING',
  SET_BANNER: 'SET_BANNER',
  SET_BANNER_ERROR: 'SET_BANNER_ERROR',
  SET_LOGO_LOADING: 'SET_LOGO_LOADING',
  SET_LOGO: 'SET_LOGO',
  SET_LOGO_ERROR: 'SET_LOGO_ERROR',

  RESET_ERROR: 'RESET_ERROR',
  RESET: 'RESET',
}

const mutations = {
  [types.SET_NEW_PROJECT_LOADING](state, value = true) {
    state.isLoading = true;
  },
  [types.SET_NEW_PROJECT](state, project) {
    state.project = project
    state.isLoading = false
  },
  [types.SET_NEW_PROJECT_ERROR](state, error) {
    state.error = error;
    state.isLoading = false;
  },

  [types.SET_BANNER_LOADING](state, value = true) {
    state.isLoadingBanner = true;
  },
  [types.SET_BANNER](state, banner) {
    state.banner = banner
    state.isLoadingBanner = false
  },
  [types.SET_BANNER_ERROR](state, error) {
    state.errorBanner = error;
    state.isLoadingBanner = false;
  },

  [types.SET_LOGO_LOADING](state, value = true) {
    state.isLoadingLogo = true;
  },
  [types.SET_LOGO](state, logo) {
    state.logo = logo
    state.isLoadingLogo = false
  },
  [types.SET_LOGO_ERROR](state, error) {
    state.errorLogo = error;
    state.isLoadingLogo = false;
  },

  [types.RESET_ERROR](state) {
    state.isLoading = false;
    state.error = null;
    state.isLoadingBanner = false;
    state.errorBanner = null;
    state.isLoadingLogo = false;
    state.errorLogo = null;
  },
  [types.RESET](state) {
    Object.assign(state, getInitialState());
  },
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
